import TonWalletButton from "./TonWalletButton";

export default TonWalletButton;